import { cn } from '@ezhire/ui';
import type { ReactNode } from 'react';

/**
 * Wraps module output so every module gets a consistent top-level layout.
 * The shell already provides chrome + padding, so this is thin.
 */
export function ModulePage({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('flex flex-col gap-6', className)}>{children}</div>;
}

export function ModuleSection({
  title,
  description,
  actions,
  children,
  className,
}: {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('flex flex-col gap-3', className)}>
      {title || actions ? (
        <header className="flex items-start justify-between gap-4">
          <div>
            {title ? <h2 className="text-h3 text-text-primary">{title}</h2> : null}
            {description ? (
              <p className="mt-1 text-caption text-text-secondary">{description}</p>
            ) : null}
          </div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
